import { type InterviewType } from '@/types/interview';

// can_purge_recording is can_edit_job? server-side: manage-all-jobs or a
// job_recruiter on this job. Swap when the backend adds can_download_recording.
export const canDownloadRecording = (interview?: InterviewType): boolean =>
  Boolean(interview?.can_purge_recording);
